import { render, staticRenderFns } from "./ImageMedia.vue?vue&type=template&id=2092a061&scoped=true&"
import script from "./ImageMedia.vue?vue&type=script&lang=js&"
export * from "./ImageMedia.vue?vue&type=script&lang=js&"
import style0 from "./ImageMedia.vue?vue&type=style&index=0&id=2092a061&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2092a061",
  null
  
)

export default component.exports